import { createApp } from "vue";
import SearchApp from "./SearchApp.vue";
import HotelSearchApp from "./HotelSearchApp.vue";
import FilterApp from "./FilterApp.vue";
import BookingApp from "./BookingApp.vue";
import store from "./store";
import routerInit from "./router";

import 'vue-universal-modal/dist/index.css';
import VueUniversalModal from 'vue-universal-modal';

import "@/scss/main.scss";
import "@/js/main.js";

if (document.getElementById('searchApp')) {
  createApp(SearchApp).use(store).use(VueUniversalModal, {
    teleportTarget: '#vue-modals',
  }).mount("#searchApp");
}

if (document.getElementById('filterApp')) {  
  createApp(FilterApp).use(store).mount("#filterApp");
}

if (document.getElementById('bookingApp')) {
  const app = createApp(BookingApp);
  // Router needs to be initiated through function to avoid being triggered on mounting the other apps ?? BUG ??
  routerInit(app, store);
  // !Important: mount only after router has been instantiated as the router-view component will not be recognised otherwise 
  app.use(store).use(VueUniversalModal, {teleportTarget: '#vue-modals',}).mount("#bookingApp");
}
